<template>
  <v-container class="form-container rounded-lg">
    <h1>New department</h1>
    <CreateForm :fields="fields" name="departments" />
  </v-container>
</template>

<script>
import { markRaw } from "vue";
import CreateForm from "@/Admin/components/CreateForm.vue";
import TextField from "@/Admin/components/form/TextField.vue";

import { ruleSetGen } from "@/Admin/helpers/rules";
export default {
  name: "DepartmentCreateView",
  components: { CreateForm },
  data() {
    return {
      fields: {
        text: {
          component: markRaw(TextField),
          data: {
            label: "Name",
            placeholder: "Enter department name",
            name: "name",
            rules: ruleSetGen.text("Enter correct key word name", true, 3),
          },
        },
      },
    };
  },
};
</script>

<style scoped>
.form-container {
  width: 1000px;
  margin: auto;
  background-color: white;
  padding: 10px;
}
</style>
